module.exports = __webpack_public_path__ + "img/Menu-08.9f1a1450.webp";